import { render, staticRenderFns } from "./RecentOrders.vue?vue&type=template&id=047a7ec6"
import script from "./RecentOrders.vue?vue&type=script&lang=js"
export * from "./RecentOrders.vue?vue&type=script&lang=js"
import style0 from "@/components/orders/styles/list.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./RecentOrders.vue?vue&type=style&index=1&id=047a7ec6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports